import { render, staticRenderFns } from "./notification-on-table.vue?vue&type=template&id=9e60c87a"
import script from "./notification-on-table.vue?vue&type=script&lang=js"
export * from "./notification-on-table.vue?vue&type=script&lang=js"
import style0 from "./notification-on-table.vue?vue&type=style&index=0&id=9e60c87a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports